import { Box, type BoxProps } from "@mui/material";

export function BoxWithBackgroundImage({ sx, ...props }: Readonly<BoxProps>) {
	return (
		<Box
			sx={{
				backgroundPosition: "center",
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				...sx,
			}}
			{...props}
		/>
	);
}
